/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type SendMessageResult = {
  /**
   * Whether the message was accepted and enqueued for processing.
   */
  accepted: boolean;
  /**
   * The chat to poll for the assistant's reply.
   */
  chatId: string;
  /**
   * The assistant thread the message was enqueued on, when the ingest produced one.
   */
  threadId?: string | undefined;
};

/** @internal */
export const SendMessageResult$inboundSchema: z.ZodMiniType<
  SendMessageResult,
  unknown
> = z.pipe(
  z.object({
    accepted: z.boolean(),
    chat_id: z.string(),
    thread_id: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "chat_id": "chatId",
      "thread_id": "threadId",
    });
  }),
);

export function sendMessageResultFromJSON(
  jsonString: string,
): SafeParseResult<SendMessageResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SendMessageResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SendMessageResult' from JSON`,
  );
}
